"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterpriseRecaptchaToken = void 0;
exports.default = EnterpriseRecaptcha;
const react_1 = __importDefault(require("react"));
const react_native_config_1 = __importDefault(require("react-native-config"));
function EnterpriseRecaptcha({ action }) {
    const siteKey = react_native_config_1.default.RECAPTCHA_SITEKEY_WEB;
    const scriptLocation = "https://www.google.com/recaptcha/enterprise.js?render=" + siteKey;
    react_1.default.useEffect(() => {
        if (!document.querySelector(`script[src="${scriptLocation}"]`)) {
            const script = document.createElement("script");
            script.src = scriptLocation;
            script.async = true;
            document.head.appendChild(script);
        }
    }, [scriptLocation]);
    return null;
}
;
class EnterpriseRecaptchaToken {
    siteKey = react_native_config_1.default.RECAPTCHA_SITEKEY_WEB;
    async getToken(action, callback) {
        // @ts-ignore - Included in helmet script load
        await grecaptcha.enterprise.ready(async () => {
            console.info("Execute token from EnterpriseRecaptchaToken");
            // @ts-ignore - Included in helmet script load
            var token = await grecaptcha.enterprise.execute(this.siteKey, { action });
            callback(token);
        });
    }
}
exports.EnterpriseRecaptchaToken = EnterpriseRecaptchaToken;
